export default "__VITE_ASSET__DLx62N5j__"